/**
 * block.js
 *
 * Handles Swiper JS for the Hero Slider
 */

class HeroSlider {
    constructor() {
        this.elements = null;
        this.grabElements();

        if (this.elements.slider.length && this.elements.slides.length > 1) {
            this.initSlider();
        }
    }

    grabElements() {
        this.elements = {
            slider: jQuery('.hero-slider__slides'),
            slides: jQuery('.hero-slider__slide')
        };
    }

    initSlider() {
        const swiperEl = this.elements.slider[0];

        const params = {
            // array with CSS styles for pagination
            injectStyles: [
                `
                .swiper-pagination-bullets.swiper-pagination-horizontal {
                    bottom: 35px;

                    @media (max-width: 766px) {
                        bottom: 50%;
                        left: unset;
                        right: 0;
                        width: auto;
                        transform: rotate(90deg) translateY(-500%);
                    }
                }
                
                .swiper-pagination-bullet {
                    transition: width 0.2s ease;
                    margin: 0 5px;
                    width: 50px;
                    height: 5px;
                    background: #fff;
                    border-radius: 40px;
                    opacity: 1;
                }

                .swiper-pagination-bullet-active {
                    width: 115px;
                    background: #fff;
                    opacity: 1;
                }
                `
            ]
        };

        Object.assign(swiperEl, params);

        swiperEl.initialize();
    }
}

jQuery(document).ready(() => {
    window.heroSlider = new HeroSlider();
});
